import { HTMLAttributes } from 'react';

import cx from 'classnames';

import Text from 'components/shared/Typography/Text';

import s from '../index.module.css';

export function HeaderButton({
  leftIcon,
  rightIcon,
  isTextVisible = true,
  isVisible = true,
  text,
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement> & {
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  isTextVisible?: boolean;
  isVisible?: boolean;
  text: string;
}) {
  return isVisible ? (
    <div className={cx(s.organizedBy, className)} {...rest}>
      {leftIcon}
      {isTextVisible && (
        <>
          <Text className={s.organizedByText}>{text}</Text>
          {rightIcon}
        </>
      )}
    </div>
  ) : null;
}
